module.exports = __webpack_public_path__ + "img/8.360123ae.png";